import React, {useContext, useState} from 'react';
import UserContext  from '../../context/Globales/UserContext';
import { TextField,
    Grid,
    Typography, 
    makeStyles, 
    TableContainer, Table, TableCell, TableRow,TableHead,TableBody} from '@material-ui/core';

    const useStyles = makeStyles((theme) => ({ 
        tituloTable: {
    
           backgroundColor: theme.palette.primary.main, 
           minWidth: 200,
           color: 'white',
           textAlign: 'center',
           padding: '10px',
           fontWeight: '250',
           fontSize : '16px'
        },  
        TituloIdentificacion: {
    
           backgroundColor: theme.palette.primary.main, 
           minWidth: 200,
           color: 'white',
           textAlign: 'center',
           padding: '15px',
           fontWeight: '250',
           fontSize : '18px',
           height: 'auto',
           alignContent: 'center',               
        },
        FondoTable :{
       
            backgroundColor: theme.palette.greyFondo.main
        },
    }));

const TblAcreditacionModal = () => {
    const classes = useStyles();
    const { datoICMODAL } = useContext(UserContext);
    const [DatoBAnco] = useState(datoICMODAL.DetalleInformacionPositiva?.MovimientosDeBancos.split(":"));
    const Bancos = DatoBAnco[1].replace(";"," ")
   // console.log(DatoBAnco);
    return (
        <div>

            <h6 className={classes.tituloTable}>Indicadores de Acreditación</h6>
            <TableContainer>
            <Table>
            <TableHead className={classes.FondoTable}>
                <TableRow>
                    <TableCell> Cantidad de Bancos que Registra {DatoBAnco[0]}</TableCell>
                    <TableCell>{ Bancos }</TableCell>
                    
                    
                </TableRow>
            </TableHead>
           
            </Table>
    
        </TableContainer>
        </div>
    )
}

export default TblAcreditacionModal;
